module.exports = __webpack_public_path__ + "static/img/biografia.ac59644.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/biografia.jpg
// module id = hXG6
// module chunks = 47